// extracted by mini-css-extract-plugin
export default {"page":"BM1_53keDc8niWF0FUwx"};